// Admin API helpers — todo pasa por el Cloudflare Worker.
// La password de admin se guarda en sessionStorage (se pierde al cerrar).

const WORKER_BASE = (
  process.env.REACT_APP_PAPI_WORKER_URL
  || "https://preguntale-a-papi.guendelman.workers.dev"
).replace(/\/ask-papi\/?$/, "").replace(/\/+$/, "");

const PASSWORD_KEY = "recetario_admin_password";

export function getAdminPassword() {
  try { return sessionStorage.getItem(PASSWORD_KEY) || ""; } catch { return ""; }
}
export function setAdminPassword(pw) {
  try { sessionStorage.setItem(PASSWORD_KEY, pw); } catch { /* silent */ }
}
export function clearAdminPassword() {
  try { sessionStorage.removeItem(PASSWORD_KEY); } catch { /* silent */ }
}

export async function checkAdminAuth(password) {
  const res = await fetch(`${WORKER_BASE}/admin-check-auth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-admin-password": password,
    },
  });
  const json = await res.json().catch(() => ({}));
  return !!json.ok;
}

export async function parseRecipe(text) {
  const password = getAdminPassword();
  const res = await fetch(`${WORKER_BASE}/admin-parse-recipe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-admin-password": password,
    },
    body: JSON.stringify({ text }),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "parse_failed");
  // json = { ok, recipe, duplicates: { exact, similar } }
  return json;
}

export async function publishRecipe(recipe, photoDataUrl) {
  const password = getAdminPassword();
  const res = await fetch(`${WORKER_BASE}/admin-publish-recipe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-admin-password": password,
    },
    body: JSON.stringify({ recipe, photo_data_url: photoDataUrl }),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "publish_failed");
  return json;
}

export async function updateRecipe(recipe, photoDataUrl) {
  const password = getAdminPassword();
  const res = await fetch(`${WORKER_BASE}/admin-update-recipe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-admin-password": password,
    },
    body: JSON.stringify({ recipe, photo_data_url: photoDataUrl || "" }),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "update_failed");
  return json;
}

export async function listRecipes() {
  // Público, no requiere auth admin — usa el JSON servido por Vercel
  const res = await fetch("/data/recipes.json", { cache: "no-store" });
  if (!res.ok) throw new Error("no_recipes");
  return res.json();
}

// PDF → texto usando pdf.js cargado dinámicamente desde CDN. Devuelve el
// texto concatenado de todas las páginas.
export async function extractPdfText(file) {
  // pdf.js 3.11.174 (versión UMD estable — main + worker mismo número).
  const PDFJS_VER = "3.11.174";
  const LIB_URL = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VER}/pdf.min.js`;
  const WORKER_URL = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VER}/pdf.worker.min.js`;

  if (!window.pdfjsLib) {
    await new Promise((res, rej) => {
      const s = document.createElement("script");
      s.src = LIB_URL;
      s.onload = res;
      s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  const lib = window.pdfjsLib;
  if (!lib) throw new Error("No se pudo cargar pdf.js");
  if (lib.GlobalWorkerOptions) {
    lib.GlobalWorkerOptions.workerSrc = WORKER_URL;
  }
  const buf = await file.arrayBuffer();
  const pdf = await lib.getDocument({ data: buf }).promise;
  let out = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    const strings = content.items.map((it) => it.str);
    out += strings.join(" ") + "\n\n";
  }
  return out.trim();
}

// ============================================================
// SUGERIR RECETAS — endpoints públicos (cualquier miembro logueado)
// ============================================================
export async function submitSuggestion(payload) {
  const res = await fetch(`${WORKER_BASE}/suggest-recipe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "suggest_failed");
  return json;
}

// Admin — protected by admin password
export async function listSuggestions() {
  const password = getAdminPassword();
  const res = await fetch(`${WORKER_BASE}/admin-list-suggestions`, {
    headers: { "x-admin-password": password },
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "list_failed");
  return json.suggestions || [];
}

export async function dismissSuggestion(id) {
  const password = getAdminPassword();
  const res = await fetch(`${WORKER_BASE}/admin-dismiss-suggestion`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "x-admin-password": password },
    body: JSON.stringify({ id }),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "dismiss_failed");
  return json;
}

export async function draftFromSuggestion(id) {
  const password = getAdminPassword();
  const res = await fetch(`${WORKER_BASE}/admin-draft-from-suggestion`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "x-admin-password": password },
    body: JSON.stringify({ id }),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "draft_failed");
  return json;
}

// ============================================================
// MENÚ SEMANAL — push diario "hoy toca X"
// ============================================================
export async function registerWeeklyMenuPush(member, days, type) {
  const res = await fetch(`${WORKER_BASE}/save-weekly-menu`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ member, days, type }),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "save_failed");
  return json;
}

export async function unregisterWeeklyMenuPush(member) {
  const res = await fetch(`${WORKER_BASE}/save-weekly-menu`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ member }),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "delete_failed");
  return json;
}

// Regenerar audio de bienvenida (voz PVC) para un miembro específico.
// variant: "full" (primera vez) o "short" (vueltas siguientes)
export async function regenerateWelcomeAudio(nick, variant = "full", text) {
  const password = getAdminPassword();
  const res = await fetch(`${WORKER_BASE}/admin-regenerate-welcome`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "x-admin-password": password },
    body: JSON.stringify({ nick, variant, text: text || undefined }),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.detail || json.error || "regen_failed");
  return json;
}
